import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your responses, it seems like the most likely cause of this dizziness is a <strong>degenerative condition like Parkinson's or Multiple Sclerosis</strong>, or from <strong className="text-decoration"> nerve damage due to diabetes or another illness.</strong> </h2>
        <p>Not only do many conditions cause dizziness or feelings of being lightheaded, but the medications used to treat them may worsen these symptoms.</p>
        <p>If this dizziness is new or if it is significantly impacting daily life, then it's best to speak with a specialist.</p>
        <p>In the meantime, check out these resources to learn more about dizziness in various degenerative conditions:</p>
        
    </div>
  )
}
